import { ChangeDetectorRef, Component, computed, inject, input, model } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { SimpleFieldDirective } from '../directives';

@Component({ template: '' })
export class BaseCustomControl<T = unknown> implements ControlValueAccessor {
  fieldAccessor = input<SimpleFieldDirective>();
  // #fieldConfig = computed(() => this.fieldAccessor()?.fieldConfig);
  options$$ = computed(() => this.fieldAccessor()?.options$$());
  keyProp = computed(() => this.fieldAccessor()?.keyProp);
  valueProp = computed(() => this.fieldAccessor()?.valueProp);
  control = computed(() => this.fieldAccessor()?.control);
  name = computed(() => this.fieldAccessor()?.name);

  controlName = computed(() => this.fieldAccessor()?.name);

  disabled = model<boolean>(false);
  value = model<T | undefined>(undefined);

  #changeDetector = inject(ChangeDetectorRef);

  protected onChange: (value: T | undefined) => T;
  protected onTouched: () => T;

  writeValue(value: T | undefined): void {
    this.value.set(value);
    const hasValueChanged = this.value() != this.control()?.value;
    if (hasValueChanged) {
      this.control().setValue(value);
    }
    this.#changeDetector.markForCheck();
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }

  registerOnChange(fn: (value: T | undefined) => T): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => T): void {
    this.onTouched = fn;
  }
}
